import PlatformMsaDocumentManagement from './PlatformMsaDocumentManagement';

export default PlatformMsaDocumentManagement;
